module.exports = __webpack_public_path__ + "media/images/games/35reveal/tree-8edfe2daaffda771ceaa99d1954624e6.png";